export default class StickyWrapper {
    
    constructor() {
        this.init();
    }



    init() {

        
        //if (!(window.navigator.userAgent.indexOf("Edg") > -1)) {

            const floatingNav = document.querySelector('.floating-navigation');
            const stickyRoot = document.querySelector('#sticky-root');

            const observer = new IntersectionObserver (entries => {
                    
                    /**entries.forEach(entry => {

                        entry.target.classList.toggle("floating-navigation--fixed", !entry.isIntersecting);

                    })**/

                    floatingNav.classList.toggle("floating-navigation--fixed", !entries[0].isIntersecting);


                }/**,
                {
                    threshold: 0
                }**/
            );


            // create the observer
// give the observer some dom nodes to keep an eye on
            observer.observe(stickyRoot);

           // observer.observe(floatingNav)


       //}



    }
}





/**

export default class StickyWrapper {
  constructor() {
    this.init();
  }

  init() {
      //Init sticky root
      this.stickyRoot = document.querySelector("#sticky-root");
      if (!this.stickyRoot) {
          this.stickyRoot = document.createElement("div");
          this.stickyRoot.id = "sticky-root";
          document.body.insertBefore(this.stickyRoot, document.body.firstChild);
      }
      this.stickyWrapper = document.createElement("div");
      this.stickyWrapper.classList.add("sticky-wrapper");
      this.stickyWrapper.classList.add("hideInAEM");
      this.stickyWrapper.style.position = "sticky";
      this.stickyWrapper.style.top = "0";
      this.stickyWrapper.style.background = "#fff";
      this.stickyWrapper.style.zIndex = "100";
      this.stickyRoot.parentElement.insertAdjacentElement(
          "afterend",
          this.stickyWrapper
      );

      this.insertionObserver = new MutationObserver((mutations) => {
          let shouldUpdate = false;
          mutations.forEach((mutation) => {
            if (mutation.type === "childList") {
              mutation.addedNodes.forEach((node) => {
                if (node.classList && node.classList.contains("sticky")) {
                  shouldUpdate = true;
                }
              });
            }
          });
          if (shouldUpdate) {
            console.log("updating sticky wrapper");
            this.update();
          }
      });
      this.update();
  }

  update() {
      if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
      }
      if (this.mutationObserver) {
          this.mutationObserver.disconnect();
      }
      
      while (this.stickyWrapper.firstChild) {
          this.stickyWrapper.removeChild(this.stickyWrapper.firstChild);
      }
      
      this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const { isIntersecting, target } = entry;
              const id = target.getAttribute("data-sticky");
              const stickyClone = document.querySelector(
                `[data-sticky-clone="${id}"]`
              );
              if (stickyClone) {
                if (isIntersecting) {
                  //hide sticky clone

                  stickyClone.style.display = "none";
                } else {
                  stickyClone.style.display = target.style.display;
                  //show sticky clone
                }
              }
            });
          },
          {
            threshold: 1,
          }
      );
      this.mutationObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "attributes") {
              if (
                mutation.attributeName !== "data-sticky" &&
                mutation.attributeName !== "style"
              ) {
                const { target } = mutation;
                const id = target.getAttribute("data-sticky");
                const stickyClone = document.querySelector(
                  `[data-sticky-clone="${id}"]`
                );
                if (stickyClone) {
                  const newClone = target.cloneNode(true);
                  newClone.setAttribute("data-sticky-clone", id);
                  newClone.style.display = stickyClone.style.display;
                  newClone.removeAttribute("data-sticky");
                  stickyClone.replaceWith(newClone);
                }
              }
            }
          });
      });

      document.querySelectorAll(".sticky").forEach((sticky, i) => {
          //add intersection observer to sticky
          this.intersectionObserver.observe(sticky);
          //add mutation observer to sticky
          this.mutationObserver.observe(sticky, {
            attributes: true,
          });

          const clone = sticky.cloneNode(true);
          sticky.setAttribute("data-sticky", i);
          clone.setAttribute("data-sticky-clone", i);

          this.stickyWrapper.appendChild(clone);
      });
  }
}
**/
